module.exports = __webpack_public_path__ + "img/silver_vip_intro.e56435ba.png";